import React from 'react';
import SignIn from './section-components/sign-up';

const SignUpPage = () => {
    return <div>
        <SignIn />
    </div>
}

export default SignUpPage

